import { render, staticRenderFns } from "./ContratFormTab.vue?vue&type=template&id=a20499b2&"
import script from "./ContratFormTab.vue?vue&type=script&lang=js&"
export * from "./ContratFormTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports